import React from 'react';
import { connect } from 'react-redux';

import BasicInfoRating from './BasicInfoRating.jsx';
import TrackRatingSection from './TrackRatingSection.jsx';
import FieldRatingSubmit from './FieldRatingSubmit.jsx';
import RatingTotal from '../RatingTotal.jsx';

import { removeNonHeaderFields } from '../../actions/form';

export class OnTrack extends React.Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.categories = APP_CONFIG.ratings.onTrack.categories;
  }

  componentWillMount() {
    this.props.removeNonHeaderFields('rating');
  }

  render() {
    return (
      <form id="on-track-rating" autoComplete="off">
        <h3>TRD Driver Rating - On Track</h3>
        <p className="subtext">All fields marked with an asterisk symbol (*) are mandatory.</p>
        <BasicInfoRating />
        <TrackRatingSection fields={this.categories.practice.ratings} title="Practice" />
        <TrackRatingSection fields={this.categories.qualifying.ratings} title="Qualifying" questionNumberOffset={7} />
        <TrackRatingSection fields={this.categories.race.ratings} title="Race" questionNumberOffset={9} />
        <TrackRatingSection fields={this.categories.general.ratings} title="General" questionNumberOffset={18} />
        <RatingTotal type="on" />
        <div className="clear"></div>
        <div className="form-submit-wrapper">
          <div className="pull-right">
            <FieldRatingSubmit
              buttonText="Submit and Rate Off Track"
              redirectTo="/rating/driver/off-track"
              formType="on"
            />
          </div>
          <div className="pull-right">
            <FieldRatingSubmit formType="on" />
          </div>
        </div>
      </form>
    );
  }
}

export default connect(
  null,
  { removeNonHeaderFields },
)(OnTrack);
